export const TEAMS_NO = {
    
}